<template>

  <div class="PayBill">
    <b-overlay
      :show="show"
      spinner-variant="primary"
      spinner-large
      rounded="sm"
      style="height:100vh"
      variant="dark"
      id="loader"
    >
    <b-row>
      <b-col cols="12 headerF"><HeaderFixed/></b-col>
      <b-col cols="12 headerM"><HeaderMobile/></b-col>
    </b-row>
      <b-container id="consBillDiv" fluid style="padding-top: 100px;text-align:left">

        <b-row>
          <b-col cols="12">
              <b-breadcrumb style=" background-color: #e9ecef78;">
                  <b-breadcrumb-item href="#home">
                    <router-link to="/">
                        <b-icon icon="house-door" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
                        Home
                    </router-link>
                  </b-breadcrumb-item>

                 <b-breadcrumb-item href="#" active>Know Your Prepaid Consumer Number</b-breadcrumb-item>
              </b-breadcrumb>
            </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <span class="title">Know Your Prepaid Consumer Number</span>
          </b-col>
        </b-row>
        <hr/>
        <div class="paddingLeft30px">
          <!-- <br>
          <p style="color:red">We are facing some technical issues with our payment gateway. This is expected to be resolved soon. Sorry for the inconvenience.</p> -->

         <b-row>
               <b-col col cols="12" sm="12" md="12" lg="3" style="padding-top: 7px;">
                     <span style="font-weight:600" >Enter Old Consumer No <span class="text-danger">*</span></span>
               </b-col>
               <b-col col cols="8" sm="8" md="8" lg="4">
                   <b-form-input type="text" maxlength="" id="oldConsNo" value=""  placeholder="Enter your Consumer Number" trim required />
               </b-col>
               <b-col col cols="4" sm="3" md="3" lg="1">
                     <b-button @click="showPrepConsDetails()" block pill variant="primary" size="md" class="go" style="width:100%">
                       <b-icon  icon="arrow-right-short" animation="" scale="1.8" >  </b-icon>
                     </b-button>

               </b-col>
          </b-row>
    </br>
    <div id="BillDetails" class="billDetails">
          <b-row>
            <b-col cols=12>
                <span class="heading">New Consumer Details</span>
            </b-col>
          </b-row>
          <hr/>


           <b-row class="paddingRow">
             <b-col cols="12" sm="6" md="6" lg="4">
               <span class="label">New 12-Digit Consumer Number : </span>
             </b-col>
             <b-col cols="12" sm="6" md="6" lg="4">
               <span class="" id="newConsNo" class="newcons" style="font-size:1.5rem"></span>
             </b-col>

           </b-row>

           <b-row class="paddingRow">
             <b-col cols="12" sm="6" md="6" lg="4">
               <span class="label">Consumer Name : </span>
             </b-col>
             <b-col cols="12" sm="6" md="6" lg="4">
               <span class="" id="consName"></span>
             </b-col>
           </b-row>

           <b-row class="paddingRow">
             <b-col cols="12" sm="6" md="6" lg="4">
               <span class="label">Consumer Address : </span>
             </b-col>
             <b-col cols="12" sm="6" md="6" lg="4">
               <span class="" id="consAddr"></span>
             </b-col>
           </b-row>
           <br>
           <p style="text-align:justify">**Dear APDCL Consumer, your consumer number has been changed from
             <span style="font-weight:600;color:red" id="oldConsNo1"></span> to <span  class="newcons" id="newConsNo1"></span>.
            Please use this new consumer number  <span class="newcons" id="newConsNo2"></span> for all transactions with APDCL (online payment, online bill view etc.).
            Please link/register your new consumer number  <span class="newcons" id="newConsNo3"></span> using the NON-RAPDR option with Google Pay, Amazon Pay etc.
            for easy online payment.
          </p>
          </div>
      </div>
  </b-container>

</b-overlay>
<b-modal id="model" centered  scrollable title="ALERT !" :static="true" hide-footer>
  <span class="data" id="msg">  </span>
  <br><br>
    <b-button  style="width:8rem" variant="outline-primary" @click="closeModal()">OK</b-button>
</b-modal>
  </div>

</template>


<script>

import HeaderFixed from '@/components/HeaderFixed.vue'
import HeaderMobile from '@/components/HeaderMobile.vue'
import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
Vue.use(Vuex)

var consNo="";
var sdCode="";
export default {
  name: 'PayBill',
  components: {

    'HeaderFixed' : HeaderFixed,
    'HeaderMobile' :HeaderMobile
    //MarqueeText

  },
data(){
  return{
    show:false
  }
},
  methods: {
    showPrepConsDetails()
    {
        var oldConsNo = document.getElementById("oldConsNo").value;

          this.show= true;
          axios.post('https://www.apdclrms.com/cbs/onlinecrm/knowNewConsNo/search?sapConsNo='+oldConsNo)
          .then((response) => {
          this.show= false;
          if(response.data.length>0)
          {
              var data=response.data[0];
              document.getElementById("newConsNo").innerHTML=data[0];
              document.getElementById("newConsNo1").innerHTML=data[0];
              document.getElementById("newConsNo2").innerHTML=data[0];
              document.getElementById("newConsNo3").innerHTML=data[0];
              document.getElementById("oldConsNo1").innerHTML=oldConsNo;
              document.getElementById("consName").innerHTML=data[1];
              document.getElementById("consAddr").innerHTML=data[2];
              document.getElementById("BillDetails").classList.add("showBillDetails");
            }
            else {
              this.$bvModal.show("model");
              document.getElementById("msg").innerHTML="Consumer Not Found";
              document.getElementById("BillDetails").classList.remove("showBillDetails");
            }
          })
          .catch((e) => {
          console.log("Caught", e);
          this.show= false;
          this.$bvModal.show("model");
          document.getElementById("msg").innerHTML="Sorry, Consumer / Bill not Found";
          document.getElementById("BillDetails").classList.remove("showBillDetails");
        })
 },
 closeModal(){
   this.$bvModal.hide('model')
 }

}
}
//background-image: url('../assets/bg.jpg');background-color: #82828226;

</script>

<style scoped="true">

.newcons{
  font-weight:600;
  color:#4caf50 ;
}
.paddingRow{
  padding:0.7rem;
}
.paddingCol{
  padding: none;
}
.label{
font-weight: 600;
}
.data{
  font-weight: 600;
  color: #ff5722         ;
  font-size: 1.5rem;
}
.billDetails
{
  visibility: hidden;
  opacity: 0;
  transition:visibility 0s, opacity 0.5s linear;
  box-shadow: 2px 2px 10px 2px #bdbdbd;
  padding: 1rem;
  margin-right: 1.5rem;
}
.showBillDetails
{

  visibility: visible;
 opacity: 1;
}
hr {
   margin-top: 5px;
   margin-bottom: 5px;
  }
.go:focus{
  box-shadow: none;
}

.headerF{
  display: block;
}
.headerM{
  display: none;
}

.paddingLeft30px{
  padding-left: 30px;
}

@media (max-width: 768px) {
    .headerF{
      display: none;
    }
    .headerM{
      display: block;
    }
    .paddingLeft30px{
      padding-left: 0px;
    }
  }
@media only screen and (max-width: 414px) {
  .paddingCol{
    padding: 0.7rem;
  }
  .paddingRow{
    padding: none !important;
  }
  .paddingLeft30px{
    padding-left: 0px;
  }
}


</style>
